import {
  call,
  fork,
  put,
  takeEvery,
  takeLatest,
  all
} from 'redux-saga/effects';
import * as ga from '../../redux/actions/app';
import { UNIFIED_ALERT_METRICS } from '../../pages/constants/commonConstants';

import {
  downloadSelectedAlertsFail,
  downloadSelectedAlertsSuccess,
  getAlertHitsData,
  getAlertHitsDataSuccess,
  getCustomerTypesSegmentFail,
  getCustomerTypesSegmentSuccess,
  getInvestListDataFail,
  getInvestListDataSuccess,
  NS_DOWNLOAD_SELECTED_LIST,
  NS_GET_ALERT_HITS_DATA,
  NS_GET_CUSTOMER_TYPE_LIST,
  NS_GET_INVEST_LIST_DATA,
  NS_SEND_TO_CM,
  sendToCMAlertsFail,
  sendToCMAlertsSuccess
} from '../../redux/actions/ns/investigation';

import { getInvestListData } from '../../services/ns/investigation';
import {
  downloadAlertsApi,
  getCustomerTypesSegmentApi,
  sendToCMApi
} from '../../services/ns/alerts';
import { getNSAlertDetailsListData } from '../../redux/actions/ns/runInstance';
import { message } from 'antd';
import {
  getAMLSCommonAlertDetails,
  getAMLSCommonUnifiedAlertCountByMetricName
} from '../../redux/actions/common';

function* getAlertHitsDataWorker(payload) {
  try {
    const response = yield call(getAlertHitsData, payload);
    yield put(getAlertHitsDataSuccess(response));
  } catch (error) {
    yield put(ga.fetchFailed({ error: '' }));
  }
}

function* getInvestListDataWorker(payload) {
  const { COUNT_FOR_PAGINATION } = UNIFIED_ALERT_METRICS;
  try {
    const [data, count] = yield all([call(getInvestListData, payload)]);

    yield put(
      getAMLSCommonUnifiedAlertCountByMetricName({
        metricName: COUNT_FOR_PAGINATION,
        data: payload
      })
    );

    yield put(getInvestListDataSuccess({ ...data, ...count }));
  } catch (error) {
    yield put(
      getInvestListDataFail({
        error: error.message || 'Something went wrong, please try again'
      })
    );
  }
}

function* downloadSelectedAlertsWorker(payload) {
  try {
    const response = yield call(downloadAlertsApi, payload);
    yield put(downloadSelectedAlertsSuccess(response));
  } catch (error) {
    yield put(downloadSelectedAlertsFail({ error: '' }));
  }
}

function* getCustomerTypesSegmentWorker(payload) {
  try {
    const response = yield call(getCustomerTypesSegmentApi, payload);
    yield put(getCustomerTypesSegmentSuccess(response));
  } catch (error) {
    yield put(getCustomerTypesSegmentFail({ error: '' }));
  }
}

function* sendToCMAlertsWorker(payload) {
  try {
    yield call(sendToCMApi, payload);
    yield put(sendToCMAlertsSuccess(payload.isFromAlertList));
    if (!payload.isFromAlertList && payload?.ids?.[0]) {
      yield put(getAMLSCommonAlertDetails({ alertId: payload?.ids[0] }));
      yield put(getNSAlertDetailsListData({ id: payload?.ids[0] }));
    }
  } catch (error) {
    message.error(error.message);
    yield put(sendToCMAlertsFail(error.message));
  }
}

export function* watchGetAlertHitsData() {
  yield takeEvery(NS_GET_ALERT_HITS_DATA, function* ({ payload }) {
    yield fork(getAlertHitsDataWorker, payload);
  });
}

export function* watchGetInvestListData() {
  yield takeLatest(NS_GET_INVEST_LIST_DATA, function* ({ payload }) {
    yield fork(getInvestListDataWorker, payload);
  });
}

export function* watchDownloadSelectedAlerts() {
  yield takeEvery(NS_DOWNLOAD_SELECTED_LIST, function* ({ payload }) {
    yield fork(downloadSelectedAlertsWorker, payload);
  });
}

export function* watchCustomerTypesSegmentAlerts() {
  yield takeEvery(NS_GET_CUSTOMER_TYPE_LIST, function* ({ payload }) {
    yield fork(getCustomerTypesSegmentWorker, payload);
  });
}

export function* watchSendToCMAlerts() {
  yield takeEvery(NS_SEND_TO_CM, function* ({ payload }) {
    yield fork(sendToCMAlertsWorker, payload);
  });
}
